module.exports = __webpack_public_path__ + "static/5-36440a6d4d1e24c155f34e4e1d42af84.jpg";